import { Injectable } from '@angular/core';
import { QueueBaseService } from '@core/services/queue/queue-base.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceLineQueueService extends QueueBaseService {
  fragment = `${this.productName.value}/ServiceLineQueues`;
  uniqueKey = 'serviceLineQueueId';
}
